export default class SelectionTable {
    selections = [];
    copy = [];
    down = {};
    hashId = '';
    status = '';
    cache = {};

    constructor(hashId) {
        this.hashId = hashId;
    }

    buildMatriz = (coordinates) => {
        this.copy = [];
        for (var i = coordinates.xLeft; i <= coordinates.xRigth; i++) {
            let columns = [];
            for (var j = coordinates.yLeft; j <= coordinates.yRigth; j++) {
                this.printSelection(i, j);
                columns.push({ x: i, y: j });
            }
            this.copy.push(columns);
        }
    };

    getById = (x, y) => document.getElementById(`{0}-row${x}-col${y}`.replace('{0}', this.hashId));

    printSelection = (x, y) => {
        const element = this.getById(x, y);
        if (!element) return;
        element.setAttribute('class', element.getAttribute('class') + ' cell-selection');
        this.selections.push(element);
    };

    clearMatriz = () => {
        this.selections.forEach((element) => {
            if (!element) return;
            element.setAttribute('class', element.getAttribute('class').replace(' cell-selection', ''));
        });
        this.selections = [];
    };

    getElementToPosition = (x, y) => {
        const element = this.getById(x, y);
        if (!element) return;

        const children = [...element.children].find((child) => ['input', 'select', 'checkbox'].includes(child.tagName.toLowerCase()));

        return children || element;
    };

    executeMagic = async (e, x, y, scroll) => {
        e.preventDefault();
        scroll(x, y);
        const element = this.getElementToPosition(x, y);

        if (!element) return;

        this.down = { x, y };
        this.clearMatriz();
        const coordinates = this.getCordinates(x, y);
        this.buildMatriz(coordinates);
        element.focus();
    };

    getLimits = (iRow, iCol, rowsLength, columnsLength) => ({
        cStart: iCol,
        cEnd: columnsLength - 1,
        rStart: iRow,
        rEnd: rowsLength - 1,
    });

    onKeyDown = (e, iRow, iCol, rowsLength, columnsLength, scroll) => {
        this.status = 'onKeyDown';

        if (e.altKey && e.which === 40) {
            const element = this.getElementToPosition(iRow, iCol);
            if (!element) return;
            return element.focus();
        }

        const { cStart, cEnd, rStart, rEnd } = this.getLimits(iRow, iCol, rowsLength, columnsLength);

        switch (e.key) {
            case 'ArrowLeft':
                return this.executeMagic(e, rStart, cStart === 0 ? 0 : cStart - 1, scroll);
            case 'ArrowRight':
                return this.executeMagic(e, rStart, cStart === cEnd ? cStart : cStart + 1, scroll);
            case 'ArrowUp':
                return this.executeMagic(e, rStart === 0 ? 0 : rStart - 1, cStart, scroll);
            case 'ArrowDown':
                return this.executeMagic(e, rStart === rEnd ? rStart : rStart + 1, cStart, scroll);
            default:
                return;
        }
    };

    onMouseDown = (e, x, y) => {
        if (e.shiftKey) return this.onShiftClick(x, y);

        this.down = { x, y };
        this.clearMatriz();
        const coordinates = this.getCordinates(x, y);
        this.buildMatriz(coordinates);
        this.status = 'onMouseDown';
    };

    onMouseEnter = (x, y) => {
        const ignores = ['onMouseUp', 'onKeyDown', 'onShiftClick'];
        if (ignores.includes(this.status) || this.selections.length === 0) return;

        this.clearMatriz();
        const coordinates = this.getCordinates(x, y);
        this.buildMatriz(coordinates);
        this.status = 'onMouseEnter';
    };

    onShiftClick = (x, y) => {
        if (this.selections.length === 0) return;

        this.clearMatriz();
        const coordinates = this.getCordinates(x, y);
        this.buildMatriz(coordinates);
        this.status = 'onShiftClick';
    };

    onMouseUp = (x, y) => {
        this.status = 'onMouseUp';
    };

    getCordinates = (x, y) => ({
        xRigth: Math.max(this.down.x, x),
        xLeft: Math.min(this.down.x, x),
        yRigth: Math.max(this.down.y, y),
        yLeft: Math.min(this.down.y, y),
    });
}
